import React from 'react'
import Footer1 from './Footer1';

const Footer = ({ basicData }) => {

    return (<Footer1 data={basicData?.data} />)
}

export default Footer